import { Spinner } from 'reactstrap';
import React from 'react';

const Loading = () => (
  <div>
    <style jsx global>
      {`
        *,
        *::before,
        *::after {
          box-sizing: border-box;
        }
        .loading {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
        }
      `}
    </style>
    <Spinner className="loading" animation="border" variant="danger" />
  </div>
);

export default Loading;
